function getProp(id){
  id = id.split('P')
  return parseInt(id[0])*1000 + (id[1] ? parseInt(id[1]) : 0)
}

export function routeSorting(a,b){
  return getProp(a.id) -  getProp(b.id)
}



/** WEBPACK FOOTER **
 ** ./src/app/utils/sorting.js
 **/